import { HTTP, HTTPResponse } from '@ionic-native/http/ngx';
import { Controls } from '../../../services/controls';
import { ClientBase } from '../HttpClientSelector';

class IonicNativeHttp implements ClientBase {
  private static _instance: IonicNativeHttp;
  private http: HTTP = new HTTP();

  private constructor() {
    this.http.setDataSerializer('json');
    this.http.setServerTrustMode('default');
  }

  public static Instance(): IonicNativeHttp {
    return this._instance || (this._instance = new this());
  }

  public Post = <TOut>(options: {
    data: any;
    contentType: string;
    baseUrl?: string;
    serviceUrl?: string;
    methodUrl?: string;
  }): Promise<TOut> => {
    const _url = (options.baseUrl || '') + (options.serviceUrl || '') + (options.methodUrl || '');
    return (this.http
      .post(_url, options.data, {
        Accept: '*/*',
        'Accept-Encoding': 'gzip, deflate, br',
        'Accept-Language': 'tr-TR,tr;q=0.9,en-US;q=0.8,en;q=0.7',
        'Content-Type': options.contentType,
        'Cache-Control': 'no-cache',
      })
      .then((res: HTTPResponse) => {
        if (Controls.IsString(res.data)) {
          try {
            res.data = JSON.parse(res.data);
          } catch (ex) {
            //do_nothing
          }
        }
        return res;
      }) as unknown) as Promise<TOut>;
  };

  public Get = <TOut>(options: {
    baseUrl?: string;
    serviceUrl?: string;
    methodUrl?: string;
  }): Promise<TOut> => {
    const _url = (options.baseUrl || '') + (options.serviceUrl || '') + (options.methodUrl || '');
    return (this.http
      .get(_url, undefined, {
        Accept: 'application/json, text/javascript, */*; q=0.01',
        'Accept-Encoding': 'gzip, deflate, br',
        'Accept-Language': 'tr-TR,tr;q=0.9,en-US;q=0.8,en;q=0.7',
        'Cache-Control': 'no-cache',
      })
      .then((res: HTTPResponse) => {
        if (Controls.IsString(res.data)) {
          try {
            res.data = JSON.parse(res.data);
          } catch (ex) {
            //do_nothing
          }
        }
        return res;
      }) as unknown) as Promise<TOut>;
  };
}

const IonicNativeHttpInstance = IonicNativeHttp.Instance();

export default IonicNativeHttpInstance;
